import { render, staticRenderFns } from "./SupplierMain.vue?vue&type=template&id=162f1b7e&scoped=true"
import script from "./SupplierMain.vue?vue&type=script&lang=js"
export * from "./SupplierMain.vue?vue&type=script&lang=js"
import style0 from "./SupplierMain.vue?vue&type=style&index=0&id=162f1b7e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162f1b7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162f1b7e')) {
      api.createRecord('162f1b7e', component.options)
    } else {
      api.reload('162f1b7e', component.options)
    }
    module.hot.accept("./SupplierMain.vue?vue&type=template&id=162f1b7e&scoped=true", function () {
      api.rerender('162f1b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/SupplierMain.vue"
export default component.exports